export default __webpack_public_path__ + "static/media/manage-accounts.e2aec775.svg";